import dayjs from 'dayjs'

const MS_PER_DAY = 24 * 60 * 60 * 1000

function toTimestamp(value?: number | Date | string): number | null {
  if (value == null || value === '') return null
  const parsed = dayjs(value)
  if (!parsed.isValid()) return null
  return parsed.valueOf()
}

export function formatDaysUntilExpiry(
  expiresAt?: number | Date | string,
): string {
  const timestamp = toTimestamp(expiresAt)
  if (timestamp == null) return 'Permanent'

  const diff = timestamp - Date.now()
  if (diff <= 0) return 'Expired'

  const days = Math.ceil(diff / MS_PER_DAY)
  if (days <= 1) return '< 1 day left'
  return `${days} days left`
}

export function formatAutoDeleteDays(autoDeleteDays: number): string {
  return autoDeleteDays === 0 ? 'Never' : `${autoDeleteDays}d`
}
